<template>
    <div class="fixed-center text-center">
        <p>
            <img src="~assets/sad.svg" style="width: 30vw; max-width: 150px" />
        </p>
        <h6 class="text-faded">
            {{ $t('Oops, the page you are looking for does not exist.') }}
            (404)
        </h6>
        <div class="row wrap justify-evenly">
            <q-btn
                color="secondary"
                style="width: 200px"
                to="/"
                :label="$t('Go back')"
            />
            <a
                href="mailto:support@iotorq-lean.com?"
                style="text-decoration: none"
            >
                <q-btn
                    color="secondary"
                    style="width: 200px"
                    :label="$t('Report an issue')"
                >
                </q-btn>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Error404'
};
</script>
